<template>
  <div id="count-wrapper">
    <div class="count-inner-container container">
      <!-- Active Agents -->
      <section class="counter-container">
        <span class="counter-title"> Active Agents </span>
        <span class="counter-number">
          {{ agents.tweened.toFixed(0) }}
        </span>
      </section>

      <!-- Airlines Agents -->
      <section class="counter-container">
        <span class="counter-title"> Airlines</span>
        <span class="counter-number">
          {{ airlines.tweened.toFixed(0) }}
        </span>
      </section>

      <!-- Hotels Agents -->
      <section class="counter-container">
        <span class="counter-title"> Hotels </span>
        <span class="counter-number">
          {{ hotels.tweened.toFixed(0) }}
        </span>
      </section>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  name: "CountNumber",
  props: {
    counter: Object,
  },
  data() {
    return {
      agents: {
        number: this.counter.agents,
        tweened: 0,
      },
      airlines: {
        number: this.counter.airlines,
        tweened: 0,
      },
      hotels: {
        number: this.counter.hotels,
        tweened: 0,
      },
    };
  },
  created() {
    const self = this;
    self;
  },
  watch: {
    "agents.number": {
      handler: function (n) {
        const self = this;
        gsap.to(self.agents, { duration: 0.5, tweened: Number(n) || 0 });
      },
      immediate: true,
    },
    "airlines.number": {
      handler: function (n) {
        const self = this;
        gsap.to(self.airlines, { duration: 0.5, tweened: Number(n) || 0 });
      },
      immediate: true,
    },
    "hotels.number": {
      handler: function (n) {
        const self = this;
        gsap.to(self.hotels, { duration: 0.5, tweened: Number(n) || 0 });
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#count-wrapper {
  .count-inner-container {
    display: grid;
    grid-template-columns: 33.33% 33.33% 33.33%;
    .counter-container {
      display: flex;
      flex-direction: column;
      align-items: center;

      .counter-number {
        font-size: 5rem;
        font-weight: 600;
      }
    }
  }
}
</style>
